import { render, staticRenderFns } from "./detailAffiliateCommission.vue?vue&type=template&id=19cb7192&scoped=true"
import script from "./detailAffiliateCommission.vue?vue&type=script&lang=js"
export * from "./detailAffiliateCommission.vue?vue&type=script&lang=js"
import style0 from "./detailAffiliateCommission.vue?vue&type=style&index=0&id=19cb7192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb7192",
  null
  
)

export default component.exports